import { TabsProducts } from '@features/products/components/productExhibition/tabs/TabsProducts';
import { ProductDto } from '@features/products/interfaces/productInterface';
import { Divider, Flex, Skeleton, Table } from 'antd';
import { ColumnType } from 'antd/lib/table';

type SkeletonProductExhibitionProps = {
  optionsTabProducts: {
    label: string;
    component: React.ReactNode;
  }[];
  columnsTable?: ColumnType<ProductDto>[];
};

export function SkeletonProductExhibition({
  optionsTabProducts,
  columnsTable,
}: SkeletonProductExhibitionProps) {
  const skeletonComponent = (
    <Skeleton.Input active size='small' style={{ width: '100%' }} />
  );

  // Adiciona skeletons em todas as colunas da tabela
  const dataSkeletons = Array.from({ length: 5 }).map((_, index) => {
    const row: any = {};
    columnsTable?.forEach(column => {
      row[column.key as string] = skeletonComponent;
    });
    row.key = index;
    return row;
  });

  // Se houver onRender nas colunas, substitui o skeleton pelo resultado de onRender
  const columnsWithRender = columnsTable?.map(column => {
    if (column.render) {
      return {
        ...column,
        render: () => skeletonComponent,
      };
    }
    return column;
  });

  return (
    <Flex vertical>
      <Skeleton.Input active />

      <Flex justify='space-between' style={{ marginTop: 4 }}>
        <Skeleton.Input active size='small' style={{ width: 261 }} />
        <Skeleton.Input active size='small' style={{ width: 421 }} />
      </Flex>

      <Divider />

      <TabsProducts
        optionsTabProducts={optionsTabProducts.map(option => ({
          ...option,
          component: <></>,
        }))}
      />

      <Skeleton.Button active size='large' block />

      <Table
        columns={columnsWithRender}
        dataSource={dataSkeletons}
        pagination={false}
        style={{ marginTop: 16 }}
      />
    </Flex>
  );
}
